// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"f473acc1","88":"749ff6a1","168":"6ff8b1ea","178":"ef57c556","201":"945c5602","242":"d65a6f2f","271":"3ff723c4","327":"c6e7f07e","377":"40f8759f","494":"429c8c9b","705":"8f1813e2","820":"2709324c","831":"45806e32","845":"811ddb9b","924":"cccebffa","930":"d71da0a5"}[chunkId] + ".chunk.js";
};